export default __webpack_public_path__ + "static/media/BJS_WHITE.91357674.png";